<script setup>
import { defineProps, defineModel, onMounted, onUnmounted } from 'vue';

const isOpen = defineModel({ default: false });

defineProps({
    title: {
        type: String,
        required: true,
    },
});

function closePanel() {
    isOpen.value = false;
}

function handleEscKey(event) {
    if (event.key === 'Escape' && isOpen.value) {
        event.stopPropagation();
        closePanel();
    }
}

onMounted(() => {
    window.addEventListener('keydown', handleEscKey);
});

onUnmounted(() => {
    window.removeEventListener('keydown', handleEscKey);
});
</script>

<template>
    <Teleport to="body">
        <Transition name="guide-overlay-fade">
            <div
                v-if="isOpen"
                class="fixed inset-0 z-[60] bg-gray-900/50 backdrop-blur-[1px]"
                @click="closePanel"
            />
        </Transition>

        <div
            class="fixed top-0 right-0 h-full w-full sm:w-[480px] md:w-[520px] bg-white shadow-2xl z-[70] transform transition-transform duration-300 ease-in-out"
            :class="isOpen ? 'translate-x-0' : 'translate-x-full'"
            role="dialog"
            aria-modal="true"
            :aria-hidden="!isOpen"
        >
            <div class="h-full flex flex-col">
                <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
                    <h3 class="text-lg font-semibold text-gray-900 pr-4">
                        {{ title }}
                    </h3>
                    <button
                        type="button"
                        class="flex items-center justify-center w-8 h-8 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                        aria-label="Закрыть"
                        @click="closePanel"
                    >
                        <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>

                <div class="flex-1 min-h-0 overflow-y-auto px-5 py-5">
                    <slot />
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped>
.guide-overlay-fade-enter-active,
.guide-overlay-fade-leave-active {
    transition: opacity 0.2s ease;
}

.guide-overlay-fade-enter-from,
.guide-overlay-fade-leave-to {
    opacity: 0;
}
</style>
